import { ReactElement } from 'react';

import { TherapeuticGroupScheduleDaySimple } from '@dreryk/egabinet-group-session-frontend-api';

import { StrongText, StyledFlex, Text, TextSeparator, TextSeparatorType } from '@dreryk/react-components';
import { commonTranslationKeys, hourMinuteFormatter, Translate } from '@dreryk/react-common';

type ScheduleDaysCellProps = {
   readonly scheduleDays: TherapeuticGroupScheduleDaySimple[];
};

export const ScheduleDaysCell = (props: ScheduleDaysCellProps): ReactElement => {
   return (
      <StyledFlex direction={'column'}>
         {props.scheduleDays.map((scheduleDay) => (
            <TextSeparator key={scheduleDay.dayOfWeek}>
               <StrongText testId={scheduleDay.dayOfWeek}>
                  <Translate>{commonTranslationKeys.dayOfWeekAbbreviationMap[scheduleDay.dayOfWeek]}</Translate>
               </StrongText>
               <TextSeparator separator={TextSeparatorType.HYPHEN}>
                  <Text testId={'startTime'}>{hourMinuteFormatter(scheduleDay.startTime)}</Text>
                  <Text testId={'endTime'}>{hourMinuteFormatter(scheduleDay.endTime)}</Text>
               </TextSeparator>
            </TextSeparator>
         ))}
      </StyledFlex>
   );
};
